import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '../shared.module';
import {
  FooterComponent,
  HeaderComponent,
  MenuComponent,
  NextPage,
} from '@cvx/nextpage';
import { AppRoutingModule } from '../app-routing.module';

const componentList = [MenuComponent, HeaderComponent, FooterComponent];

@NgModule({
  imports: [BrowserAnimationsModule, AppRoutingModule, NextPage],
  exports: [MenuComponent, FooterComponent, HeaderComponent, AppRoutingModule],
})
export class MenuModule {}
